import { faPencilSlash } from '@fortawesome/pro-solid-svg-icons';
import type { FC } from 'react';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import {
  TooltipBehavior, TooltipComponent,
} from '~/_shared/baseComponents/tooltip/tooltip.component';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';

const containerStyle = (theme: Theme) => ({
  color: theme.textColors.warning,
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
});

const iconStyle = {
  flexShrink: 0,
  width: '20px',
  marginRight: '4px',
};

const textStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 0,
};

export const ReadOnlyWarningComponent: FC = () => {
  const [t] = useTranslation();

  return (
    <div css={containerStyle}>
      <span css={iconStyle}>
        <FontAwesomeIcon
          icon={faPencilSlash}
        />
      </span>
      <TooltipComponent
        tooltipContent={t('readOnlyMode.explanation')}
        behavior={TooltipBehavior.ShowOnHover}
      >
        <span css={textStyle}>{t('readOnlyMode.name')}</span>
      </TooltipComponent>
    </div>
  );
};
